export default __webpack_public_path__ + "static/media/rides-to-school.b0d71112.jpg";